import { setGLTFStatus } from './GLTF';
import { addNewSceneObject } from './store';
import { deepCopy, uuid, zTimestamp } from './utils';
export const copyObject = (obj) => {
    const [pX, pY, pZ] = obj.position;
    const offsetPosition = [pX + 2, pY, pZ];
    if (obj.type === 'MESH') {
        addNewSceneObject(copyMesh(obj, offsetPosition), true);
    }
    else if (obj.type === 'LIGHT') {
        // return copyLight
        addNewSceneObject(copyLight(obj, offsetPosition), true);
    }
    else if (obj.type === 'GLTF') {
        // return copyGLTF
        const newGLTF = copyGLTF(obj, offsetPosition);
        addNewSceneObject(newGLTF, true);
        setGLTFStatus(newGLTF.id, "EMPTY");
    }
};
const copyMesh = (mesh, offsetPosition) => {
    let rotation = deepCopy(mesh.rotation);
    let scale = deepCopy(mesh.scale);
    return Object.assign(Object.assign({}, mesh), { id: uuid(), position: [...offsetPosition], scale,
        rotation, name: `${mesh.name} COPY ${zTimestamp()}`, geometry: mesh.geometry.clone(), material: mesh.material.clone() });
};
const copyLight = (light, offsetPosition) => {
    return Object.assign(Object.assign({}, light), { id: uuid(), name: `${light.name} COPY ${zTimestamp()}`, position: [...offsetPosition] });
};
const copyGLTF = (gltf, offsetPosition) => {
    let rotation = deepCopy(gltf.rotation);
    let scale = deepCopy(gltf.scale);
    return Object.assign(Object.assign({}, gltf), { id: uuid(), position: [...offsetPosition], scale,
        rotation, name: `${gltf.name} COPY ${zTimestamp()}`, model: null });
};
